import React from 'react';
import Mapa from '../../assets/img/Mapa.png';
import { segments, segmentsSection } from '../../content/siteContent';
import SectionHead from './SectionHead';
import { StrokeIcon } from './Icons';

export default function Segments() {
  return (
    <section className="section-wrap section-wrap--band">
      <SectionHead tag={segmentsSection.tag} title={segmentsSection.title} subtitle={segmentsSection.subtitle} />

      <div className="segments-layout">
        <div className="segments-map">
          <img
            src={Mapa}
            alt="Mapa do Brasil com a presença da BlackBelt IT Solutions por região"
            className="segments-map-img"
            width="834"
            height="834"
            loading="lazy"
          />
        </div>

        <div className="segments-grid">
          {segments.map((segment) => (
            <div className="segment-card" key={segment.title}>
              <div className="hex-icon">
                <StrokeIcon name={segment.icon} size={22} />
              </div>
              <h3 className="segment-title">{segment.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
